import { BeforeAfter } from './before-after';
import { BeforeAfterFields } from "./before-after.fields";
import type { BeforeAfterProps } from './before-after';
import type { ComponentConfig } from "@puckeditor/core";
import { ImagePicker } from "../editor/ImagePicker";
import { RegenerableTextField } from "../editor/RegenerableTextField";
import { SliderWiggleField } from "./slider-wiggle.fields";
import { getWindowJobsiteConfig } from "../../types/runtime-config";

const BeforeAfterConfig: ComponentConfig<BeforeAfterProps> = {
  defaultProps: {
    afterLabel: "After",
    aspectRatio: "4:3",
    beforeLabel: "Before",
    ctaHref: "",
    ctaText: "",
    heading: "Before and After",
    pairs: [
      {
        afterFocus: "center",
        afterImageUrl: "",
        alt: "",
        beforeFocus: "center",
        beforeImageUrl: "",
        caption: "",
      },
    ],
    sliderWiggle: "on",
    startPosition: "half",
    subheading: "Drag the handle to see real transformations from recent jobs.",
  },
  fields: {
    heading: {
      ...BeforeAfterFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="beforeAfter.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...BeforeAfterFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="beforeAfter.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    pairs: {
      ...BeforeAfterFields.pairs,
      arrayFields: {
        ...BeforeAfterFields.pairs.arrayFields,
        beforeImageUrl: {
          ...BeforeAfterFields.pairs.arrayFields.beforeImageUrl,
          render: ({
            value,
            onChange,
          }: {
            value?: string;
            onChange: (val: string | undefined) => void;
          }) => <ImagePicker value={value || ""} onChange={onChange} label="Before Photo" />,
        },
        afterImageUrl: {
          ...BeforeAfterFields.pairs.arrayFields.afterImageUrl,
          render: ({
            value,
            onChange,
          }: {
            value?: string;
            onChange: (val: string | undefined) => void;
          }) => <ImagePicker value={value || ""} onChange={onChange} label="After Photo" />,
        },
      },
    } as any,
    beforeLabel: BeforeAfterFields.beforeLabel,
    afterLabel: BeforeAfterFields.afterLabel,
    aspectRatio: BeforeAfterFields.aspectRatio,
    startPosition: BeforeAfterFields.startPosition,
    ctaText: BeforeAfterFields.ctaText,
    ctaHref: BeforeAfterFields.ctaHref,
    backgroundColor: BeforeAfterFields.backgroundColor,
    sliderWiggle: SliderWiggleField,
  },
  label: "Before & After",
  render: ({ id, puck: _puck, editMode, ...props }) => {
    const windowConfig = getWindowJobsiteConfig();
    return (
      <BeforeAfter
        id={id}
        {...props}
        isEditing={Boolean(windowConfig?.isEditing ?? editMode)}
      />
    );
  },
  /** The link field only matters once there is button text; hide it until then. */
  resolveFields: (data, { fields }) => {
    const ctaText = (data.props as { ctaText?: string })?.ctaText;
    if ((ctaText ?? "") !== "") {
      return fields;
    }
    const trimmed = { ...fields } as Record<string, unknown>;
    delete trimmed.ctaHref;
    return trimmed;
  },
};

export { BeforeAfterConfig };
